<template>
    <div class="panel-body">
        <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" :atras="atras" />

        <h5 class="regisTituloUsuario">Auditoria Oxyflow</h5>

        <br />

        <iframe
            src="/metabase/public/dashboard/cf18970c-dd19-4c88-87dd-0583bf780a69"
            frameborder="0"
            width="100%"
            height="600px"
            allowtransparency>
        </iframe>
    </div>
</template>

<script>
import HeaderGeneral from "../../components/HeaderGeneral.vue";

export default {
    name: "InformeAuditor",
    components: {
        HeaderGeneral
    },
    data() {
        return {
            vista: "Auditoria Oxyflow",
            carpeta: "Prestadores",
            proveniente: " - Informe Solicitudes",
            atras: false
        };
    }
};
</script>

<style scoped>
.regisTituloUsuario {
    font-size: 20px !important;
    text-align: left !important;
    font-weight: 100 !important;
    color: var(--blue-violet);
}
</style>
